import React, { forwardRef, useEffect, useImperativeHandle, useMemo, useRef, useState } from 'react'
import { useSetState } from 'ahooks'
import { Button, Checkbox, Input, message, Radio, Select, Spin, Tooltip, TreeSelect } from 'antd'
import { SGeneralForms, SLocalSelected, SLocalTreeSelected, SSegmentedTabs } from 'shj-components'
import {
  getGeneralList,
  getProductEnums,
  getSubPackTreeEditTreeTopList,
  getUpdateNodes,
  subPackTreeTempSave,
} from '@/services/product.ts'
import { debounce, isEmpty } from 'lodash-es'
import { getRoleList, getRolePage } from '@/services/homeService.ts'
import { useParams } from 'react-router-dom'
import { treeToOneArr } from '@/common/utils.ts'
import { replaceRule } from '@/utils/data.ts'
import RulesModal from '@/pages/baseProduct/components/RuleModal/RulesModal'
import _ from 'lodash'
import { QuestionCircleOutlined } from '@ant-design/icons'

type IProps = {
  fn: () => void
  onClose: () => void
  record: Record<string, any>
  dataSource?: any[]
  readOnly?: boolean
  companyList: any[]
  options: {}
}

export const AddOrEditGeneral = forwardRef((props: any, ref) => {
  const { id } = useParams()
  const { record = {}, dataSource = [], readOnly = false, companyList } = props
  const formRef = useRef()
  const [optionList, setOptionList] = useState([{ id: '0', name: '通用' }, ...companyList])

  const [state, setState] = useSetState<any>({
    roleList: [],
    searchRoleValue: '',
    selectedRoleList: [], // 选中的过滤角色list
    filterRoleList: [], // 过滤角色list
    projectList: [],
    generalList: [],
    initValues: {},
    loading: false,
    requiredDisabled: false,
    projectName: '', // 只读模式下 项目名称
    updateNodesList: [], // 更新节点
    
  })
  const [ruleModal, setRuleModal] = useSetState({
    open: false,
    mode: 'modal',
    value: '',
  })
  useEffect(() => {
    console.log(record, '-------初始化record数据')
    setRuleModal({ value: '' })
    if (record.id) {
      const shops = record?.shops || []
      const roles = record?.roles || []
      const rule = JSON.parse(record.changeLevelScope || null)?.rule || ''
      const parentId = record.parentId !== '0' ? record.parentId : ''
      const obj = {
        ...record,
        parentId,
      }
      onFormRef()?.setFieldsValue({ ...obj })
      setState({ initValues: { ...obj, shops, roles } })
      setRuleModal({ value: rule })
    } else if (record.parentId) {
      onFormRef()?.setFieldsValue({ ...record })
      setState({ requiredDisabled: record.isMust })
    }
    shopsControl(record.shops|| ['0'])
     // 添加更新节点
        if (record.updateNodesList?.length) {
          setState({
            updateNodesList: record.updateNodesList,
          })
        } else {
          getUpdateNodes().then((res: any) => {
            setState({
              updateNodesList:
                res?.map(item => {
                  return {
                    ...item,
                    checked: record.updateNodes ? record.updateNodes?.includes(item.node) : false,
                  }
                }) || [],
            })
          })
        }
  }, [record, state.filterRoleList])

  useEffect(() => {
    getRole()
    getProjectList()
    if (readOnly) {
      getProjectName()
    }
  }, [])

  const getProjectList = () => {
    if (id) {
      setState({ projectList: props.submitInfo?.treeNodes })
    } else {
      setState({ projectList: dataSource })
    }
  }

  const getRole = async () => {
    const data: any = await getRoleList({ data: { enabled: true } })
    setState({ filterRoleList: data || [] })
  }

  const onFormRef = () => {
    const { onFormRef } = formRef.current || {}
    return onFormRef?.()
  }
  const getOptions = async (): Promise<{ [key: string]: any }> => {
    setState({ loading: true })
    const roleList = await getProductEnums('com.shj.saas.plus.product.enums.RoleFilterTypeEnum')
    const generalList = await getGeneralList({ enabled: true })
    setState({
      roleList: roleList.map(item => ({ label: item.description, value: item.key })),
      generalList,
      loading: false,
    })
    return Promise.resolve({ ...props?.options, generalList })
  }

  const getShopArr = codeArr => {
    return optionList?.reduce((res, item) => {
      if (codeArr.includes(item.id)) res.push({ id: item.id, companyName: item.name })
      return res
    }, [])
  }

  const onFinish = () => {
    return new Promise((resolve, reject) => {
      onFormRef()
        ?.validateFields()
        .then(values => {
          console.log(values, '表单数据，未转化')
          props.setLoading?.(true)
          const shopList = values.shops ? getShopArr(values.shops) : []
          const object = state.generalList.find(item => item.id === values.busId)
          // const showName = state.generalList.find(item => item.id === values.busId)?.itemName
          const newValues = {
            id: values.id,
            parentId: values.parentId || '0',
            oldParentId: record?.parentId || '',
            busId: values.busId,
            dtlName: object.itemName,
            shopList: shopList,
            shops: values.shops,
            roleFilterValue: values.roleFilterValue,
            isMust: values.isMust,
            isSubtract: values.isSubtract,
            isCopy: values.isCopy,
            isShowOrder: values.isShowOrder,
            roleFilterType: values.roleFilterType,
            busType: 'PRD_GEN_ITEM',
            busTypeName: '通项',
            object,
            changeLevelScope: JSON.stringify({ rule: ruleModal.value }),
            updateNodesList: state?.updateNodesList, // 更新节点
            updateNodes: state?.updateNodesList
              .filter(item => item.checked)
              ?.map(item => item.node),
          }
          resolve(newValues)
        })
    })
  }
  useImperativeHandle(ref, () => {
    return {
      onFinish,
    }
  }, [onFinish])

  const getProjectName = () => {
    let projectName = ''
    projectName = props.treeNodes?.find(item => item.id === record.parentId)?.dtlName
    setState({ projectName })
  }
  const shopsControl = (value: any) => {
    let newOption: any = _.cloneDeep(optionList)
    if (value?.length) {
      if (value.includes('0')) {
        newOption = newOption.map((item: any) => {
          return {
            ...item,
            disabled: item.id !== '0',
          }
        })
      } else {
        newOption = newOption.map((item: any) => {
          return {
            ...item,
            disabled: item.id === '0',
          }
        })
      }
    } else {
      newOption = newOption.map((item: any) => {
        return {
          ...item,
          disabled: false,
        }
      })
    }
    setOptionList(newOption)
  }

   // 更新节点
   const onChangeTime = e => {
    const newList = state.updateNodesList
    console.log(e)
    console.log(newList)
    newList.forEach((item: any) => {
      if (e.target.value === 'BEFORE_START_WORK' && e.target.checked) {
        item.checked = true
      } else if (e.target.value === 'BEFORE_SIGN' && !e.target.checked) {
        item.checked = false
      } else if (item.node === e.target.value) {
        item.checked = e.target.checked
      }
    })
    setState({
      updateNodesList: [...newList],
    })
    onFormRef()?.setFieldsValue({
      updateNodesList: [...newList],
    })
  }
  return (
    <Spin spinning={state.loading}>
      <SGeneralForms
        ref={formRef}
        isHideGobackBtn={true}
        isDetail={readOnly}
        httpOptionsFn={getOptions}
        initialValues={
          !record.id
            ? {
                isMust: true,
                isCopy: true,
                isShowOrder: true,
                isSubtract: true,
                // standardFlag: true,
                roleFilterType: 'NONE_FILTER',
                shops: ['0'],
              }
            : {}
        }
        layout="vertical"
        titleMode={props.readOnly ? '' : 'edit'}
        configs={[
          {
            title: '基础信息',
            formItem: [
              { name: 'id', hidden: true },
              {
                name: 'parentId',
                label: '所属项目',
                spanCol: 24,
                children: readOnly ? (
                  <div>{state.projectName}</div>
                ) : (
                  <Select
                    placeholder={'请选择所属项目'}
                    options={state.projectList.filter(item => item.busType === 'PRD_PROJECT')}
                    fieldNames={{ label: 'dtlName', value: 'id' }}
                  />
                ),
              },
              {
                name: 'busId',
                label: '通项',
                required: true,
                rules: [{ required: true, message: '通项不能为空' }],
                spanCol: 24,
                data: 'generalList',
                type: 'select',
                comConfig: {
                  fieldNames: { label: 'itemName', value: 'id' },
                },
              },
            ],
          },
          {
            title: '打包配置',
            titleMode: 'drawer',
            formItem: [
              {
                name: 'isMust',
                label: '是否必选',
                spanCol: 24,
                type: 'switch',
                comConfig: {
                  disabled: state.requiredDisabled,
                  checkedChildren: '是',
                  unCheckedChildren: '否',
                },
              },
              // {
              //   name: 'standardFlag',
              //   label: '是否标配',
              //   spanCol: 24,
              //   type: 'switch',
              //   comConfig: {
              //     checkedChildren: '是',
              //     unCheckedChildren: '否',
              //   },
              // },
              {
                label: '升降级范围',
                spanCol: 24,
                [props.readOnly ? 'name' : '']: 'changeLevelScope',
                children: readOnly ? (
                  <span>{replaceRule(ruleModal.value)}</span>
                ) : (
                  <div>
                    <Button onClick={() => setRuleModal({ open: true })}>编辑规则</Button>
                    {ruleModal?.value && (
                      <Input.TextArea
                        autoSize={{ minRows: 1, maxRows: 4 }}
                        disabled
                        style={{ marginTop: 6 }}
                        value={replaceRule(ruleModal.value)}
                      />
                    )}
                  </div>
                ),
              },
              {
                name: 'isSubtract',
                label: '是否可减项',
                spanCol: 24,
                type: 'switch',
                comConfig: {
                  checkedChildren: '是',
                  unCheckedChildren: '否',
                },
                isDeps: true,
                // deps: form => form.getFieldValue('isMust'),
              },
              {
                name: 'isCopy',
                label: '是否允许复制',
                spanCol: 24,
                type: 'switch',
                comConfig: {
                  checkedChildren: '是',
                  unCheckedChildren: '否',
                },
              },
            ],
          },
          {
            title: '显示配置',
            titleMode: 'drawer',
            formItem: [
              {
                name: 'isShowOrder',
                label: '下单时是否显示',
                spanCol: 24,
                type: 'switch',
                comConfig: {
                  checkedChildren: '是',
                  unCheckedChildren: '否',
                },
              },
              {
                name: 'roleFilterType',
                label: '系统角色过滤',
                spanCol: 24,
                children: readOnly ? (
                  <div>
                    {state.roleList.find(item => item.value === record?.roleFilterType)?.label}
                  </div>
                ) : (
                  <Radio.Group options={state.roleList} />
                ),
              },
              {
                name: 'roleFilterValue',
                label: '过滤角色',
                spanCol: 24,
                required: true,
                rules: [{ required: true, message: '过滤角色不能为空' }],
                isDeps: true,
                deps: form => form.getFieldValue('roleFilterType') !== 'NONE_FILTER',
                children: readOnly ? (
                  <div>{state.initValues.roles?.map(item => item.name)?.join(', ')}</div>
                ) : (
                  <SLocalSelected
                    optionsData={state.filterRoleList}
                    placeholder={'输入搜索过滤角色'}
                    configData={{ label: 'name', value: 'id' }}
                    mode={'multiple'}
                    onChange={(_, o) => {
                      setState({
                        selectedRoleList: o.map(item => ({
                          id: item.value,
                          name: item.children,
                        })),
                      })
                    }}
                  />
                ),
              },
            ],
          },
          {
            title: '适用渠道',
            titleMode: 'drawer',
            formItem: [
              {
                name: 'shops',
                label: '适用门店',
                spanCol: 24,
                children: readOnly ? (
                  <div>{state.initValues.shopList?.map(item => item.companyName)?.join(', ')}</div>
                ) : (
                  <Select
                    mode={'multiple'}
                    optionFilterProp={'name'}
                    placeholder={'请选择适用门店'}
                    fieldNames={{ label: 'name', value: 'id' }}
                    onChange={(value, option) => {
                      shopsControl(value)
                    }}
                    options={optionList}
                  />
                ),
              },
            ],
          },
          {
            title: '更新配置',
            formItem: [
              {
                name: 'updateNodes',
                label: (
                  <>
                    <Tooltip title="该项数据新增或编辑后，对订单商品哪些节点的报价生效。注意：默认所有新增报价均会生效。">
                      <span>
                        <QuestionCircleOutlined /> 更新节点
                      </span>
                    </Tooltip>
                  </>
                ),
                spanCol: 24,
                children: (
                  <>
                    {state.updateNodesList?.map((item, index) => {
                      return (
                        <Checkbox
                          key={index}
                          checked={item.checked}
                          value={item.node}
                          onChange={onChangeTime}
                          disabled={readOnly}
                        >
                          {item.name}
                        </Checkbox>
                      )
                    })}
                  </>
                ),
              },
            ],
          },
        ]}
      />
      <RulesModal
        modalProps={{ ...ruleModal }}
        // type={'subItem'}
        type={'productFilterRule'}
        onCancel={() => setRuleModal({ open: false })}
        onOk={(value: string) => setRuleModal({ value })}
      />
    </Spin>
  )
})
